import { render, staticRenderFns } from "./new-source.vue?vue&type=template&id=60629ae5"
import script from "./new-source.vue?vue&type=script&lang=js"
export * from "./new-source.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60629ae5')) {
      api.createRecord('60629ae5', component.options)
    } else {
      api.reload('60629ae5', component.options)
    }
    module.hot.accept("./new-source.vue?vue&type=template&id=60629ae5", function () {
      api.rerender('60629ae5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rule-engine/data-source/new-source.vue"
export default component.exports